const agentsList = [];
const currentAgent = {}
const productList = []

export default {
  agentsList,
  currentAgent,
  productList,
};
